import { api } from './api';

// Define a service using a base URL and expected endpoints
export const applicationApi = api.injectEndpoints({
  reducerPath: 'applicationApi',
  tagTypes: [
    'AppInfo',
    'Applications',
    'ConfFiles',
    'CustomMessages',
    'ViewInitialData',
    'OpenIdConf'
  ],
  endpoints: (builder) => ({
    getApplicationInfo: builder.query({
      query: () => ({
        url: 'public/api/info',
        method: 'GET'
      }),
      providesTags: ['AppInfo']
    }),
    getConfiguration: builder.query({
      query: ({ appCode }) => ({
        url: `public/api/applications/${appCode?.toUpperCase()}/conf`,
        method: 'GET'
      }),
      providesTags: ['ConfFiles']
    }),
    getCurrentApplication: builder.query({
      query: () => ({
        url: `public/api/applications/current`,
        method: 'GET'
      }),
      providesTags: ['Applications']
    }),
    getCustomMessages: builder.query({
      query: () => ({
        url: `public/api/applications/ui/messages`,
        method: 'GET'
      }),
      providesTags: ['CustomMessages']
    }),
    getViewInitialData: builder.query({
      query: ({ viewName, componentName }) => ({
        url: `public/api/applications/view/init`,
        method: 'GET',
        params: { viewName, componentName }
      }),
      providesTags: ['ViewInitialData']
    }),
    getOpenIDConfiguration: builder.query({
      query: () => ({
        url: `public/api/conf/openid`,
        method: 'GET'
      }),
      providesTags: ['OpenIdConf']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetApplicationInfoQuery,
  useGetConfigurationQuery,
  useGetOpenIDConfigurationQuery,
  useGetCurrentApplicationQuery,
  useGetCustomMessagesQuery,
  useGetViewInitialDataQuery
} = applicationApi;
